import Immutable from 'seamless-immutable';
import { createReducer } from 'redux-act';

import LostPasswordPanelActions from './actions';

const initialState = Immutable({
  email: '',
});

export default createReducer(on => {
  on(LostPasswordPanelActions.updateField, (state, { fieldId, value }) => {
    return state.set(fieldId, value);
  });
}, initialState);
